import { Link } from 'react-router-dom';
import { Button } from '@crazyegginc/hatch';

import { useSelectedSite } from '/src/hooks';
import { Paywall } from '/src/components/Paywall';

import FunnelsPNG from '@crazyegginc/hatch/dist/images/illustration-funnels2.png';
import FunnelsWebP from '@crazyegginc/hatch/dist/images/illustration-funnels2.webp';

export function CreateGoalWall() {
  const { selectedSite } = useSelectedSite();

  return (
    <div className="flex-1 justify-center flex mt-28">
      <Paywall>
        <Paywall.Image webp={FunnelsWebP} fallback={FunnelsPNG} width="253px" />
        <Paywall.Title>Track Conversions to Start Building Your Funnel</Paywall.Title>

        <Paywall.Body>
          <p className="max-w-md">
            Track conversions to mark each step in your funnel. Once added, you&lsquo;ll see conversion rates and
            drop-offs through the user journey.
          </p>
        </Paywall.Body>

        <Button component={Link} to={{ pathname: '/goals/new', search: `site=${selectedSite.name}` }}>
          Track a Conversion
        </Button>
      </Paywall>
    </div>
  );
}
